<script>
    import Window from "../components/Window.svelte";
    import {wallet_injected, unlock_requested, unlock} from "../stores/wallet";

    export let depth;
    export let toFront = ()=>{};
    export let minimise = ()=>{};
    export let active;

    export let openWindow = (window)=>{};
</script>

<style>
        button{
                font-size: 20px;
        }
</style>

<Window depth={depth} toFront={toFront}  active={active} name="HOME" minimise={minimise}>
        <h1>POW NFT DROPS</h1>
        <button on:click={()=>{openWindow("about");}} >About</button>
        <button on:click={()=>{openWindow("drops");}} >Drops</button>
        <button on:click={()=>{openWindow("recentClaims");}} >Recent Claims</button>

        {#if $wallet_injected}
                <button on:click={()=>{openWindow("add");}} >Add</button>
                <button on:click={()=>{openWindow("claimable");}} >Claimable</button>
        {/if}
</Window>
